import { ExternalLink, Copy, Plus } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { fmtPrice } from "@/lib/api";

const host = (u) => { try { return new URL(u).hostname.replace("www.", ""); } catch { return u; } };

export const ListingCard = ({ l, selected, onToggle, cheapest, index, onAdd }) => (
  <div data-testid={`listing-card-${l.id}`}
    className={`rise relative bg-card border rounded-sm p-5 flex flex-col gap-3 transition-colors ${selected ? "border-primary" : "border-border hover:border-slate-600"}`}
    style={{ animationDelay: `${index * 0.04}s` }}>
    {cheapest && (
      <span className="absolute -top-2.5 left-4 bg-emerald-500 text-[#0B0F17] font-mono text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-sm" data-testid={`cheapest-badge-${l.id}`}>
        Lowest price
      </span>
    )}
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="font-mono text-[11px] uppercase tracking-widest text-primary truncate">{l.seller || host(l.url)}</p>
        <h3 className="font-sans text-base font-semibold leading-snug mt-1 line-clamp-2" data-testid={`listing-title-${l.id}`}>{l.title}</h3>
      </div>
      <label className="flex items-center gap-2 shrink-0 cursor-pointer text-xs text-muted-foreground">
        <Checkbox checked={selected} onCheckedChange={() => onToggle(l.id)} data-testid={`compare-checkbox-${l.id}`} />
        Compare
      </label>
    </div>
    <div className="flex flex-wrap gap-2 text-xs">
      {l.brand && <span className="px-2 py-0.5 bg-secondary rounded-sm">{l.brand}</span>}
      {l.condition && <span className="px-2 py-0.5 bg-secondary rounded-sm">{l.condition}</span>}
      {l.part_number && (
        <button type="button" data-testid={`copy-partnumber-${l.id}`}
          onClick={() => { navigator.clipboard?.writeText(l.part_number); toast.success("Part number copied"); }}
          className="px-2 py-0.5 rounded-sm border border-amber-500/30 font-mono uppercase tracking-wider text-amber-400 flex items-center gap-1 hover:bg-amber-500/10">
          {l.part_number} <Copy className="h-3 w-3" />
        </button>
      )}
    </div>
    {l.fitment_notes && <p className="text-sm text-muted-foreground leading-relaxed">{l.fitment_notes}</p>}
    <div className="mt-auto pt-3 border-t border-border flex items-end justify-between gap-3">
      <div>
        <p className="font-display text-3xl font-bold leading-none" data-testid={`listing-price-${l.id}`}>{fmtPrice(l.price, l.currency)}</p>
        {l.shipping && <p className="text-xs text-muted-foreground mt-1">{l.shipping}</p>}
      </div>
      <div className="flex items-center gap-4">
        {onAdd && (
          <button type="button" onClick={onAdd} data-testid={`add-to-wo-${l.id}`}
            className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wider bg-primary text-white px-2.5 py-1.5 rounded-sm hover:bg-orange-600">
            <Plus className="h-3.5 w-3.5" /> Add to WO
          </button>
        )}
        <a href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`seller-buy-link-${l.id}`}
          className="flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-orange-400 transition-colors">
          View <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>
  </div>
);
